import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import {RestapiService} from '../restapi.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-admin-file-view',
  templateUrl: './admin-file-view.component.html',
  styleUrls: ['./admin-file-view.component.css']
})
export class AdminFileViewComponent implements OnInit {
  respObject: any;
  respObj: any;
  fileMData: any;
  fileHead="";
  fileData:any;
  fileType="";
  tabDetails =[];
  sheetIndex = 0;
  fileId = 0;
  safeHtml: SafeHtml;

  pageDetails= "";
  pageType="";
  pageYear="";
  pageMonth="";
  pageQuarter="";
  pageStr = "";
  constructor(private router: Router,private route: ActivatedRoute, private _rest: RestapiService,private sanitizer: DomSanitizer) { 
  	//private route: ActivatedRoute;
  }
ngOnInit(): void {
  this.route.params.forEach((params: Params) => {
      this.fileId=params['id'];
      var sibx = 0;
      if(params['sheetIndex']!= undefined){
        sibx = params['sheetIndex'];
        this.sheetIndex = params['sheetIndex'];
      }
      if(params['pageDetails']!= undefined){
        this.pageDetails = params['pageDetails'];
      }
      //alert(sibx);
      var data = {
        fileId: params['id'],
        sheetIndex:sibx
      }
      this._rest.getFileDetails(data).subscribe((res) => {
        this.respObject = res;
        this.fileData=this.respObject.resp;
        //this.fileType = this.respObject.templateType;
        //console.log(this.fileData);
        if(this.fileData.sheetNames!=undefined){
          var sts = JSON.parse(this.fileData.sheetNames);
          this.tabDetails = sts;
          this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.respObject.resp.content);
          //document.getElementById("bootstrap-data-table").innerHTML=this.respObject.resp.content;
        }
      });
      this._rest.getFileDetailsById(data).subscribe((res) => {
        this.respObj = res;
        if(this.respObj.error==0){
          this.fileMData=this.respObj.resp;
          for (var xx=0;xx<this.fileMData.length;xx++){
            if(this.fileMData[xx].templateType!=""){
              this.fileHead = "Details of "+this.fileMData[xx].templateType;
            }
            if(this.fileMData[xx].monthly!=""){
              this.fileHead += " "+this.fileMData[xx].monthly;
            }
            if(this.fileMData[xx].quarterly!=""){
              this.fileHead += " "+this.fileMData[xx].quarterly;
            }
            if(this.fileMData[xx].year!=""){
              this.fileHead += " "+this.fileMData[xx].year;
            }
            if(this.fileMData[xx].companyName!=""){
              this.fileHead += " of "+this.fileMData[xx].companyName;
            }
          }
        }
        
        
      });

    });
  }
  gotoFile(id,index){
    this.router.navigate(['/admin/fileview/'+id+'/'+index]);
    this.ngOnInit();
  }
  backfile(){
    this.router.navigate(['/admin/filelist']);
  }

}

